import gql from "graphql-tag";

export const CamposDatosMarca = `{
    id_marca
    tipo_header {
      id_tipografia
      nombre_tipografia
      url_tipografia
    }
    tipo_body {
      id_tipografia
      nombre_tipografia
      url_tipografia
    }
    url_imagen
    colores {
      id_color
      color
      is_primary
    }
  }`;

export const GET_DATOS_MARCA = gql`
query GetDatosMarca {
  GetDatosMarca ${CamposDatosMarca}
}
`;

export const GET_FONTS = gql`
  query ListTipografias {
    ListTipografias {
      id_tipografia
      nombre_tipografia
      url_tipografia
    }
  }
`;

/**
 * Obtiene todas las listas de contacto disponibles para la empresa autenticada.
 * Incluye los destinatarios asociados a cada lista.
 */
export const LIST_LISTAS_CONTACTOS = gql`
  query ListListasContactos {
    ListListasContactos {
      id_lista
      nombre_lista
      destinatarios {
        id_destinatario
        tipo_destinatario
        variable_destinatario
        datos {
          id
          nombre
          lista {
            id_usuario
            primer_nombre
            segundo_nombre
            apellido_paterno
            apellido_materno
            correo
          }
        }
      }
    }
  }
`;

/**
 * Lista los contactos de correo de la empresa (por email) para mostrarlos en el gestor de contactos.
 */
export const LIST_CONTACTOS_BY_EMAIL = gql`
  query ListContactosByEmail {
    ListContactosByEmail {
      id_usuario
      primer_nombre
      segundo_nombre
      apellido_paterno
      apellido_materno
      correo
      cargo {
        id_cargo
        nombre_cargo
      }
      grupo {
        id_grupo
        nombre_grupo
        descripcion_grupo
        grupoAcciones {
          id_grupo_modulo_accion
          nombre
          descripcion
          accionesModulos {
            id_modulo_accion
            nombre
          }
        }
      }
      area: gerencia {
        id_gerencia
        nombre_gerencia
        bussiness_unit
        unit_number
      }
    }
  }
`;

export const GET_LIST_REMITENTES_EMPRESA = gql`
  query ListRemitentesEmpresa {
    ListRemitentesEmpresa {
      id_remitente
      nombre_remitent
      correo_remitente
      id_estado_fk
    }
  }
`;

export const GET_DATOS_DASHBOARD = gql`
  query DashboardBuilder($year: String, $month: String) {
    DashboardBuilder(year: $year, month: $month) {
      correos_creados
      correos_destinados
      correos_enviados
      correos_abiertos
      detalles_categoria {
        id_categoria
        nombre_categoria
        color
        correos_creados
        correos_destinados
        correos_enviados
        correos_abiertos
        correos_rebotados
        correos_clicks
      }
      detalles_top_vistos {
        id_correo
        asunto
        fecha_envio
        correos_destinados
        correos_enviados
        correos_abiertos
      }
    }
  }
`;

export const FIND_CORREO_BY_ID = gql`
  query FindCorreoId($idCorreo: Int!) {
    FindCorreoId(id_correo: $idCorreo) {
    id_correo
    remitente {
      id_remitente
      nombre_remitent
      correo_remitente
      id_estado_fk
    }
    nombre_remitente
    asunto
    introduccion
    adjuntos {
      id_adjunto
      url_adjunto
      nombre_adjunto
      size
    }
    destinatarios {
      id_destinatario
      correos_excluidos
      usuario {
        id_usuario
        primer_nombre
        segundo_nombre
        apellido_paterno
        apellido_materno
        rut_usuario
        dv_usuario
        correo
      }
      lista {
        id_lista
        nombre_lista
        destinatarios {
          id_destinatario
          tipo_destinatario
          variable_destinatario
          datos {
            id
            nombre
            lista {
              id_usuario
              primer_nombre
              segundo_nombre
              apellido_paterno
              apellido_materno
              rut_usuario
              dv_usuario
              correo
            }
          }
        }
      }
    }
    estado {
      id_estado
      nombre_estado
      color
      orden
      is_initialization
      is_deleted
      is_sended
    }
    categoria {
      id_categoria
      nombre_categoria
      color
    }
    contenido_html
    contenido_json
    fecha_envio
    correos_detinados
    correos_enviados
    tasa_apertura
    tasa_acciones
    porcentaje_apertura
    tasa_play_video
    fecha_creacion
  }
  }
`;

export const GET_PAGINACION_CONTACTOS_LISTA = gql`
  query PaginacionContactosLista(
    $limite: Int!
    $idGerencia: Int
    $nombre: String
  ) {
    PaginacionContactosLista(
      limite: $limite
      id_gerencia: $idGerencia
      nombre: $nombre
    ) {
      pagina
      ids
    }
  }
`;

export const GET_LIST_CONTACTOS_USUARIOS = gql`
  query ListContactosUsuarios($idUsuario: [Int]!) {
    ListContactosUsuarios(id_usuario: $idUsuario) {
      id_usuario
      primer_nombre
      segundo_nombre
      apellido_paterno
      apellido_materno
      imagen_perfil
      correo
      cargo {
        id_cargo
        nombre_cargo
      }
      lista_contactos {
        id_lista
        nombre_lista
        can_delete
      }
      area: gerencia {
        id_gerencia
        nombre_gerencia
        bussiness_unit
        unit_number
      }
    }
  }
`;
// Nombre y cargo de cada usuario, para el selector de jefe de EPP
// (store/modules/epp/Jefes.js). Se pide para todos los ids de la búsqueda, por
// eso trae solo lo que el selector muestra: "Nombre - Cargo"
export const GET_LIST_CONTACTOS_USUARIOS_OPTS = gql`
  query ListContactosUsuarios($idUsuario: [Int]!) {
    ListContactosUsuarios(id_usuario: $idUsuario) {
      id_usuario
      primer_nombre
      segundo_nombre
      apellido_paterno
      apellido_materno
      cargo {
        id_cargo
        nombre_cargo
      }
    }
  }
`;

export const FIND_CORREO_BY_ID_ALL = gql`
  query FindCorreoId($idCorreo: Int!) {
    FindCorreoId(id_correo: $idCorreo) {
    id_correo
    remitente {
      id_remitente
      nombre_remitent
      correo_remitente
      id_estado_fk
    }
    nombre_remitente
    asunto
    introduccion
    adjuntos {
      id_adjunto
      url_adjunto
      nombre_adjunto
      size
    }
    destinatarios {
      id_destinatario
      correos_excluidos
      usuario {
        id_usuario
        primer_nombre
        segundo_nombre
        apellido_paterno
        apellido_materno
        rut_usuario
        dv_usuario
        correo
      }
      lista {
        id_lista
        nombre_lista
        destinatarios {
          id_destinatario
          tipo_destinatario
          variable_destinatario
          datos {
            id
            nombre
            lista {
              id_usuario
              primer_nombre
              segundo_nombre
              apellido_paterno
              apellido_materno
              rut_usuario
              dv_usuario
              correo
            }
          }
        }
      }
    }
    estado {
      id_estado
      nombre_estado
      color
      orden
      is_initialization
      is_deleted
      is_sended
    }
    categoria {
      id_categoria
      nombre_categoria
      color
    }
    contenido_html
    contenido_json
    fecha_envio
    correos_detinados
    correos_enviados
    tasa_apertura
    tasa_acciones
    porcentaje_apertura
    tasa_play_video
    fecha_creacion
  }
  }
`;

export const DATOS_GRAFICA_MES_YEAR = gql`
  query DatosGraficaMesYear($year: String!) {
    DatosGraficaMesYear(year: $year) {
      month
      name_month
      correos_enviados
      correos_abiertos
    }
  }
`;

export const GET_DATES_DASHBOARD = gql`
  query FindDatesDashboard {
    FindDatesDashboard {
      year
      months
    }
  }
`;

export const REPORTE_DASHBOARD = gql`
  query FindCorreoReporteDates($fechaInicio: String!, $fechaFin: String!) {
    FindCorreoReporteDates(fecha_inicio: $fechaInicio, fecha_fin: $fechaFin) {
      id_correo
      remitente {
        nombre_remitent
        correo_remitente
      }
      nombre_remitente
      asunto
      introduccion
      adjuntos {
        url_adjunto
        nombre_adjunto
      }
      estado {
        nombre_estado
      }
      categoria {
        nombre_categoria
      }
      fecha_envio
      correos_detinados
      correos_enviados
      tasa_apertura
      tasa_acciones
      porcentaje_apertura
      tasa_play_video
      fecha_creacion
      destinatarios {
        usuario {
          primer_nombre
          apellido_paterno
          correo
        }
        lista {
          nombre_lista
        }
      }
    }
  }
`;

export const GET_PAGINACION_CORREOS = gql`
  query GetPaginacionCorreos(
    $fechaInicio: String!
    $fechaFin: String!
    $idCategoria: Int!
    $idEstado: Int!
    $limite: Int!
  ) {
    GetPaginacionCorreos(
      fecha_inicio: $fechaInicio
      fecha_fin: $fechaFin
      id_categoria: $idCategoria
      id_estado: $idEstado
      limite: $limite
    ) {
      pagina
      ids
    }
  }
`;

export const GET_PAGE_CORREOS = gql`
  query FindCorreosArray($idCorreo: [Int]!) {
    FindCorreosArray(id_correo: $idCorreo) {
      id_correo
      asunto
      correos_enviados
      fecha_creacion
      fecha_envio
      
      porcentaje_apertura
      tasa_apertura
      tasa_play_video
      tasa_acciones

      destinatarios {
        usuario {
          id_usuario
          primer_nombre
          segundo_nombre
          apellido_paterno
          apellido_materno
          rut_usuario
          dv_usuario
          correo
        }
        lista {
          id_lista
          nombre_lista
          destinatarios {
            id_destinatario
            tipo_destinatario
            variable_destinatario
            datos {
              nombre
              id
            }
          }
        }
      }
      estado {
        id_estado
        nombre_estado
      }
      categoria {
        nombre_categoria
      }
    }
  }
`;

export const GET_CATEGORIAS_MAIL = gql`
  query GetCategoriasTemplates($optionAll: Boolean) {
    GetCategoriasTemplates(optionAll: $optionAll) {
      id_categoria
      nombre_categoria
      color
    }
  }
`;
export const GET_TEMPLATES_BY_CATEGORIA = gql`
  query GetListaTemplates($idCategoria: Int!) {
    GetListaTemplates(id_categoria: $idCategoria) {
      id_template
      titulo
      descripcion
      id_categoria_fk
      id_estado_fk
      url_imagen
      contenido_html
      contenido_json
      fecha_creacion
      fecha_modificacion
    }
  }
`;

export const GET_LIST_CORREOS_AUTOMATIZADOS = gql`
  query GetListCorreosAutomatizados {
    GetListCorreosAutomatizados {
      id_template
      titulo
      descripcion
      id_categoria_fk
      id_estado_fk
      url_imagen
      contenido_html
      contenido_json
      is_automatico
      cadencia_envio
      is_active
      by_ingreso
      by_nacimiento
      destinatarios
      dia_envio
      fecha_envio
      hora_envio
      fecha_creacion
      fecha_modificacion
      categoria {
        id_categoria
        nombre_categoria
        color
      }
      remitente {
        id_remitente
        nombre_remitent
        correo_remitente
        id_estado_fk
      }
    }
  }
`;

export const GET_ESTADOS_MAIL = gql`
  query ListEstadosCorreo {
    ListEstadosCorreo {
      id_estado
      nombre_estado
      color
      orden
      is_initialization
      is_deleted
      is_sended
    }
  }
`;
